module.exports = __webpack_public_path__ + "static/media/baby_branco-800x800.1064ddd0.webp";